import { render } from "./AccordionComponent.vue?vue&type=template&id=cc75bae8"
import script from "./AccordionComponent.vue?vue&type=script&lang=js"
export * from "./AccordionComponent.vue?vue&type=script&lang=js"

import "./AccordionComponent.vue?vue&type=style&index=0&id=cc75bae8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__